import { render } from "./AccountComponent.vue?vue&type=template&id=3b7d9b98"
import script from "./AccountComponent.vue?vue&type=script&lang=js"
export * from "./AccountComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/AccountComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b7d9b98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b7d9b98', __exports__)) {
    api.reload('3b7d9b98', __exports__)
  }
  
  module.hot.accept("./AccountComponent.vue?vue&type=template&id=3b7d9b98", () => {
    api.rerender('3b7d9b98', render)
  })

}


export default __exports__